import gql from "graphql-tag";

export const GET_TRANSACTION = gql`
    query transaction($_id: GraphQLObjectId!, $includeVersions: Boolean = false) {
        transaction(_id: $_id) {
            _id
            number
            clientId
            brokerId
            carryOwnCostDate
            externalId
            uniqueTradeId
            brokerTradeId
            clearingHouseId
            tradeTimestamp
            tradeDate
            type
            description
            status
            bestExecutionType
            error
            createTimestamp
            updateTimestamp
            updateUserId
            updateUserInfo {
                name
            }
            source
            attachments {
                fileId
                fileName
                mimeType
                mD5
                updateTimestamp
            }
            items {
                _id
                clientId
                transactionId
                transactionStatus
                transactionTradeDate
                transactionType
                performanceType
                portfolioInstrumentId
                amount
                currency
                externalAccountId
                fxRate
                instrumentId
                price
                quantity
                type
                valueDate
                accountId
                bankAccountTransactionIds
                error
            }
            versions @include(if: $includeVersions)
        }
    }
`;

export const UPDATE_TRANSACTIONS = gql`
    mutation updateTransactions($input: [UpdateTransactionInput!]!) {
        transactions: updateTransactions(input: $input) {
            _id
            number
            clientId
            brokerId
            clearingHouseId
            carryOwnCostDate
            externalId
            uniqueTradeId
            brokerTradeId
            tradeTimestamp
            type
            description
            status
            bestExecutionType
            error
            createTimestamp
            updateTimestamp
            updateUserId
            source
            client {
                externalAccounts {
                    _id
                    type
                    name
                }
            }
            attachments {
                fileId
                fileName
                mimeType
                mD5
                updateTimestamp
            }
            items {
                _id
                transactionId
                performanceType
                portfolioInstrumentId
                amount
                currency
                externalAccountId
                fxRate
                instrumentId
                price
                quantity
                type
                valueDate
                accountId
            }
        }
    }
`;

export const CREATE_TRANSACTION = gql`
    mutation createTransaction($input: CreateTransactionInput!) {
        transaction: createTransaction(input: $input) {
            _id
            number
            clientId
            brokerId
            carryOwnCostDate
            externalId
            uniqueTradeId
            brokerTradeId
            tradeTimestamp
            type
            description
            status
            clearingHouseId
            bestExecutionType
            error
            createTimestamp
            updateTimestamp
            updateUserId
            source
            attachments {
                fileId
                fileName
                mimeType
                mD5
                updateTimestamp
            }
            items {
                _id
                transactionId
                performanceType
                portfolioInstrumentId
                amount
                currency
                externalAccountId
                fxRate
                instrumentId
                price
                quantity
                type
                valueDate
                accountId
            }
        }
    }
`;
